<template>
  <div id="app">
    <router-view />
    <footer class="site-footer">
      <p class="disclaimer">平台数据来自网络爬虫或群友自发贡献，具体以官方为准。</p>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">黔ICP备2023003520号-4</a>
    </footer>
  </div>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  line-height: 1.6;
  color: #1d2129;
  background-color: #f5f6f8;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#app .page {
  flex: 1 0 auto;
  min-height: 0;
}

.site-footer {
  background: #f5f5f7;
  padding: 16px 22px 22px;
  text-align: center;
  color: #c9cdd4;
  font-size: 12px;
}

.site-footer .disclaimer {
  margin: 0 0 6px;
  font-size: 12px;
  line-height: 1.5;
  color: #c9cdd4;
}

.site-footer a {
  color: #86868b;
  text-decoration: none;
}

.site-footer a:hover {
  color: #0066cc;
}
</style>
